import { writable } from 'svelte/store';

export type JobFiltersState = {
  query: string;
  locations: string[];
  isRemote: boolean;
  teams: string[];
  employeeTypes: string[];
  businessUnits: string[];
};

function createJobFiltersStore() {
  const defaultFilters = {
    query: '',
    locations: [],
    isRemote: false,
    teams: [],
    employeeTypes: [],
    businessUnits: []
  };

  const store = writable<JobFiltersState>(defaultFilters);

  function reset() {
    store.update(() => defaultFilters);
  }

  return {
    ...store,
    reset
  };
}

export const jobsFiltersStore = createJobFiltersStore();
